import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { shareReplay, catchError, switchMap, tap } from 'rxjs/operators';
import { WindowRefService } from '../../../../services/window-ref.service';
import { SessionStorageService } from '../../../../services/web-storage/session-storage.service';
import { ContentVersioningService } from '../content-versioning/content-versioning.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../../services/window-ref.service";
import * as i3 from "../content-versioning/content-versioning.service";
import * as i4 from "../../../../services/web-storage/session-storage.service";
var AppMessagesService = /** @class */ (function () {
    function AppMessagesService(http, windowRefService, contentVersioningService, sessionStorageService) {
        this.http = http;
        this.windowRefService = windowRefService;
        this.contentVersioningService = contentVersioningService;
        this.sessionStorageService = sessionStorageService;
        this.dataStoreKey = 'maAppMessages';
    }
    /**
     * @returns app messages
     */
    AppMessagesService.prototype.getAppMessages = function () {
        var _this = this;
        var storageValue = this.sessionStorageService.getItem(this.dataStoreKey, true);
        if (storageValue) {
            return of(storageValue);
        }
        if (this.messagesObservable) {
            return this.messagesObservable;
        }
        var url = this.getApiUrl();
        this.messagesObservable = this.contentVersioningService.getVersion('app-messages').pipe(switchMap(function (version) {
            return _this.http.get(url + "?v=" + version);
        }), tap(function (appMessages) {
            _this.sessionStorageService.setItem(_this.dataStoreKey, appMessages, true);
        }), catchError(function (error) {
            return of(null);
        }), shareReplay(1));
        return this.messagesObservable;
    };
    AppMessagesService.prototype.getApiUrl = function () {
        return this.windowRefService.nativeWindow.environment.CONTENT_CDN_URL +
            '/mypru/v2/node/app-messages.json';
    };
    AppMessagesService.ngInjectableDef = i0.defineInjectable({ factory: function AppMessagesService_Factory() { return new AppMessagesService(i0.inject(i1.HttpClient), i0.inject(i2.WindowRefService), i0.inject(i3.ContentVersioningService), i0.inject(i4.SessionStorageService)); }, token: AppMessagesService, providedIn: "root" });
    return AppMessagesService;
}());
export { AppMessagesService };
